import React, { Component, Fragment } from 'react';
import '../global';

class FeaturedBookCover extends Component {
    constructor(props) {
        super(props);
        this.state = {
            itemsAdded: [],
        }
        this.book_cat_slug = props.book.cat_slug;
        this.display_title = props.book.display_title;
        this.title = props.book.title;
        this.excerpt = props.book.excerpt;
        this.member_price = props.book.member_price;
        this.non_member_price = props.book.non_member_price;
        this.kinetix_code = props.book.kinetix_code;
        this.electronic_code = props.book.electronic_code;
        this.hardcover_code = props.book.hardcover_code;
        this.class = props.book.class;
        this.is_logged_in = getBookStoreObj().is_logged_in;
        this.permalink = props.book.permalink;
        this.libraryAccessStatus = ISDA_Main.libraryAccessStatus;
        this.is_set_to_free_book = props.book.is_set_to_free_book;
        this.ol_download_id = props.book.ol_download_id;
        this.olplus_download_id = props.book.olplus_download_id;
        this.ol_download_permalink = props.book.ol_download_permalink || false;
        this.olplus_download_permalink = props.book.olplus_download_permalink || false;
        this.kinetix_book_url = props.book.kinetix_book_url || false;
        this.cart = localStorage.getItem( 'bookstoreCart' ) || [];
        this.handleAddToCart = this.handleAddToCart.bind(this);
    }

    handleAddToCart(productCode) {
        this.setState({
            itemsAdded: [...this.state.itemsAdded, productCode]
        });
    }

    getLibraryButtons(){

         return (
            <Fragment>
                {this.kinetix_code ? (
                    <a href={this.kinetix_book_url}
                       className="btn btn-default btn-dl-ol"
                       data-imiscode={this.kinetix_code}>
                        Go To MyLibrary
                    </a>
                ) : (
                    <>
                        {this.libraryAccessStatus === 'LIB' && this.ol_download_id && (
                            <div className="bookstore-buttons-container">
                                <a href={this.ol_download_permalink}
                                   className="btn btn-default btn-dl-ol"
                                   data-imiscode={this.electronic_code}>
                                    Download
                                </a>
                            </div>
                        )}
                        {this.libraryAccessStatus === 'PLUS' && this.olplus_download_id && (
                            <div className="bookstore-buttons-container">
                                <a href={this.olplus_download_permalink}
                                   className="btn btn-default btn-dl-ol-plus"
                                   data-imiscode={this.electronic_code}>
                                    Download
                                </a>
                            </div>
                        )}
                    </>
                )}
            </Fragment>
        )

    }

    getPurchaseKinetixButton(){
        const isInCart = this.cart.includes(this.kinetix_code) || this.state.itemsAdded.includes(this.kinetix_code);
        const canAddToCart = this.is_logged_in && !isInCart;

        return (
            <a
                // href={this.is_logged_in && !isInCart ? `/books/cart?add=${this.kinetix_code}` : '#'}
                className={`btn btn-default btn-add-books ${!this.is_logged_in && 'btn-add-to-cart-login'} ${(canAddToCart) && 'btn-add-to-cart'} kinetix`}
                data-iMIScode={this.kinetix_code} disabled={isInCart}
                onClick={ canAddToCart ? () => this.handleAddToCart(this.kinetix_code) : null}
            >
                {isInCart ? 'Item in Cart' : 'Purchase One-Year Subscription'}
            </a>
        )
    }

    getBuyEbookButton(){
        const isInCart = this.cart.includes(this.electronic_code) || this.state.itemsAdded.includes(this.electronic_code);
        const canAddToCart = this.is_logged_in && !isInCart;
        return (
            <a
                href={this.is_logged_in && !isInCart ? `/books/cart?add=${this.electronic_code}` : '#'}
                className={`btn btn-default btn-add-books ${!this.is_logged_in && 'btn-add-to-cart-login'} ${(canAddToCart) && 'btn-add-to-cart'} e-book`}
                data-iMIScode={this.electronic_code} disabled={isInCart}
                onClick={ canAddToCart ? this.handleAddToCart : null}
            >
                {isInCart ? 'Item in Cart' : 'Buy E-book'}
            </a>
        )
    }

    getNonLibraryButtons(){
        return (
            <Fragment>
                                    <div className="book-price-container">
                        <div className="book-price">
                            <span className="book-price__label">Member /</span>
                            <span className="book-price__label">Non-member</span>
                            <span className="book-price__price">
                                <span className="aria-hidden">$</span>
                                {this.member_price}
                                /
                                <span className="aria-hidden">$</span>
                                {this.non_member_price}
                            </span>
                        </div>
                    </div>
        {this.kinetix_code ? 
            this.getPurchaseKinetixButton()
         : (
            <div className="bookstore-add-to-cart-container">
                {this.getBuyEbookButton()}

                {this.hardcover_code && (
                    <a
                        href={this.is_logged_in ? `/books/cart?add=${this.hardcover_code}` : '#'}
                        name="add hardcopy to cart"
                        className={`btn btn-default btn-add-books ${this.is_logged_in ? 'btn-add-to-cart' : 'btn-add-to-cart-login'}`}
                        data-iMIScode={this.hardcover_code}
                        
                    >
                        Buy Print
                    </a>
                )}
                    </div>
                )}
            </Fragment>
        )
    }

    render() {
        return (
            <Fragment>
                <div className={this.class}>
            <div class="bookstore-cover-wrap">
			<div className={"bookstore-cover category-" + this.book_cat_slug}>
				<h3 className="bookstore-cover__title ellipsis-title-large" aria-hidden="true"> {this.display_title || this.title} </h3>
            </div>
            <svg class="bookstore-cover__bookmark" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"
	 fill="none">
	<path d="M2.37417 19.625C2.82921 19.8195 3.33229 19.8723 3.8178 19.7765C4.3033 19.6808 4.74868 19.441 5.09584 19.0883L10 14.2108L14.9042 19.0883C15.1328 19.3203 15.4052 19.5047 15.7056 19.6307C16.006 19.7567 16.3284 19.8219 16.6542 19.8225C16.989 19.8215 17.3204 19.7544 17.6292 19.625C18.0879 19.4393 18.48 19.1197 18.7543 18.7077C19.0286 18.2958 19.1723 17.8107 19.1667 17.3158V4.16667C19.1653 3.062 18.7259 2.00296 17.9448 1.22185C17.1637 0.440735 16.1047 0.00132321 15 0L5 0C3.89534 0.00132321 2.8363 0.440735 2.05519 1.22185C1.27407 2.00296 0.834659 3.062 0.833336 4.16667V17.3158C0.827958 17.8111 0.97215 18.2964 1.24706 18.7084C1.52196 19.1204 1.91479 19.4399 2.37417 19.625Z"
                    fill="#C6A57D"/>
                </svg>
            </div>

            <div class="bookstore-info">
            <h3 class="book-title">
            <a href={this.permalink}
                           data-bookid={this.book_id}>
                            {this.title}
                        </a>
                    </h3>
                    <div class="book-excerpt">
                        {/* <div dangerouslySetInnerHTML={{__html: this.excerpt}} /> */}
                    </div>
            {/* /*Buttons Here */ }
                <div className="bookstore-ctas">

                    {(this.libraryAccessStatus === 'PLUS' || this.libraryAccessStatus === 'LIB' || this.is_set_to_free_book) && this.getLibraryButtons()}
                    {this.libraryAccessStatus !== 'PLUS' && this.libraryAccessStatus !== 'LIB' && this.getNonLibraryButtons()}
                        </div>
                    </div>
                    </div>


            </Fragment>
        );
    }
}

export default FeaturedBookCover;